export default {
      id: "recording-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#recording-usage",
      toString: function () {
        return this.url;
      }
    }